module.exports = __webpack_public_path__ + "img/exam-typical-user.517ced1e.png";